import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { TimeService } from '../time.service';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {
  confirm = false;
  yes = true;
  unsubscribeNow = true;
  dialogData: any = {};
  subStatus = '';
  consent = '';
  carrier = '';
  message = '';
  dateTime = '';
  constructor(private dialog: MatDialogRef<SubscribeComponent>, @Inject(MAT_DIALOG_DATA) private parentData: any,
              private http: HttpService, private snackbar: SnackbarService,
              private timeService: TimeService) { }

  ngOnInit() {
    this.dialogData.id = this.parentData.data._id;
    this.dialogData.sin = this.parentData.data.sin;
    this.dialogData.status = this.parentData.data.status;
    this.subStatus = (this.parentData.response.isSubscribed) ? 'Yes' : 'No';
    this.consent = (this.parentData.response.isConsent) ? 'Yes' : 'No';
    this.carrier = (this.parentData.response.carrier) ? this.parentData.response.carrier : '';
    this.message = (this.parentData.response.message) ? this.parentData.response.message : '';
    this.dateTime = (this.parentData.response.consentDate) ? this.timeService.toShortDate(this.parentData.response.consentDate) : '';
  }
  closeDialog() {
    this.dialog.close();
  }
  unsubscribe() {
    
    this.confirm = false;
    this.http.post('shipment/simTrack/unsubscribe', {id: this.dialogData.id}).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.subStatus = data.data.isSubscribed;
          this.consent = data.data.isConsent;
          this.unsubscribeNow = false;
          this.confirm = false;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  subscribe() {
    this.http.post('shipment/simTrack/subscribe', {id: this.dialogData.id}).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.subStatus = data.data.isSubscribed;
          this.consent = data.data.isConsent;
          this.unsubscribeNow = false;
          this.confirm = false;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
}
